import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { Filter } from '../models/review/filter.model';
import { SavedFilters } from 'src/app/models/SavedFilters';
import { QuickLinkUpdate } from '../components/review/quick-links/quick-link-update';
import { FilterFieldGroup } from '../components/dialogs/select-filter-new/models/filter-field-group';
import { SavedFilter } from 'src/app/components/dialogs/select-filter-new/models/saved-filter';

@Injectable({
  providedIn: 'root'
})
export class FilterService implements QuickLinkUpdate {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  public getFilters(): Observable<Filter[]> {
    return this.http.get<Filter[]>(`${this.appConfigService.getConfig().webApi}/api2/filters`)
     .pipe(catchError(this.errorHandler.handleError<Filter[]>(`get filters`)));
  }

  public getFilter(filterId: string): Observable<Filter> {
    return this.http.get<Filter>(`${this.appConfigService.getConfig().webApi}/api2/filters/${filterId}`)
      .pipe(catchError(this.errorHandler.handleError<Filter>(`get filter ${filterId}`)));
  }

  public getFilterFields(): Observable<FilterFieldGroup[]> {
    return this.http.get<FilterFieldGroup[]>(`${this.appConfigService.getConfig().webApi}/api2/FilterFields`)
      .pipe(catchError(this.errorHandler.handleError<FilterFieldGroup[]>(`get field filters`)));
  }

  public saveFilter(filter: SavedFilters | SavedFilter): Observable<Filter> {
    return this.http.post<Filter>(`${this.appConfigService.getConfig().webApi}/api2/filters`, filter)
      .pipe(catchError(this.errorHandler.handleError<Filter>(`post filters`)));
  }

  public updateLink(filter: Filter): Observable<Filter> {
    return this.http.put<Filter>(`${this.appConfigService.getConfig().webApi}/api2/filters/${filter.savedFilterId}`, filter).pipe(
      catchError(this.errorHandler.handleError<Filter>(`[PUT] Filters failed for FilterId=${filter.savedFilterId}`)));
  }
}
